import { SidenavItemInterface } from "src/app/shared/side-nav/interfaces/side-nav-items.interface";

export const adminSideNavConfig: SidenavItemInterface[] = [
  {
    id: 'admin_users',
    label: 'adminUsers',
    routerLink: '/admin-users',
  },
   {
    id: 'admin_roles',
    label: 'adminRoles',
    routerLink: '/admin-roles',
  },
    {
    id: 'interest-rate-bracket',
    label: 'interestRateBracket',
    routerLink: '/interest-rate-bracket',
  },
];
